import { IProduct } from "./models/Product";
const removeDuplicate = (payload: IProduct[]) =>
  payload.filter(
    (accessories: IProduct, index: number, self: IProduct[]) =>
      index ===
      self.findIndex(
        (findIdx: IProduct) =>
          accessories["articleNumber"] === findIdx["articleNumber"]
      )
  );

export default removeDuplicate;
